function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#footer-line_svg__clip0_414_52768)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M146.586 141.003C47.616 154.803-1 116.465-1 116.465v462.538h1452.5L1439 43.078S1308.24-6.099 1202.25 8.817c-105.99 14.915-181.34 61.928-282.023 55.46C819.546 57.81 700.663 13.66 556.5 24.143 412.337 34.625 383 56.197 298.126 91.243c-63.494 26.218-99.567 42.514-151.54 49.76z",
  stroke: "#235544",
  strokeWidth: 3
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "footer-line_svg__clip0_414_52768"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h1437v150H0z"
})));

function SvgFooterLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1437,
    height: 150,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQzNyIgaGVpZ2h0PSIxNTAiIHZpZXdCb3g9IjAgMCAxNDM3IDE1MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzQxNF81Mjc2OCkiPgo8cGF0aCBkPSJNMTQ2LjU4NiAxNDEuMDAzQzQ3LjYxNiAxNTQuODAzIC0xIDExNi40NjUgLTEgMTE2LjQ2NVY1NzkuMDAzSDE0NTEuNUwxNDM5IDQzLjA3OEMxNDM5IDQzLjA3OCAxMzA4LjI0IC02LjA5ODY4IDEyMDIuMjUgOC44MTY4NUMxMDk2LjI2IDIzLjczMjQgMTAyMC45MSA3MC43NDU0IDkyMC4yMjcgNjQuMjc3N0M4MTkuNTQ2IDU3LjgxIDcwMC42NjMgMTMuNjU5MiA1NTYuNSAyNC4xNDE5QzQxMi4zMzcgMzQuNjI0NiAzODMgNTYuMTk3MiAyOTguMTI2IDkxLjI0MzFDMjM0LjYzMiAxMTcuNDYxIDE5OC41NTkgMTMzLjc1NyAxNDYuNTg2IDE0MS4wMDNaIiBzdHJva2U9IiMyMzU1NDQiIHN0cm9rZS13aWR0aD0iMyIvPgo8L2c+CjxkZWZzPgo8Y2xpcFBhdGggaWQ9ImNsaXAwXzQxNF81Mjc2OCI+CjxyZWN0IHdpZHRoPSIxNDM3IiBoZWlnaHQ9IjE1MCIgZmlsbD0id2hpdGUiLz4KPC9jbGlwUGF0aD4KPC9kZWZzPgo8L3N2Zz4K";
export { SvgFooterLine as ReactComponent };